/*
 * Ryan O'Dowd
 * 2025-05-13
 * © Copyright 2025 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */
import {
  Outlet,
} from 'react-router';

export default Outlet;
